// Mock data for Klinara Kids Pre-school

export const schoolInfo = {
  name: "Klinara Kids",
  tagline: "Nurturing Young Minds with Asian Values",
  established: "2026",
  location: "Hyderabad",
  address: "Road no 10, AGRL Housing colony, Hastinapuram, Hyderabad - 500079",
  phone: "7673920886",
  email: "admissions@klinarakids.com",
  logo: "https://customer-assets.emergentagent.com/job_kinara-preschool/artifacts/9e5vyuoe_WhatsApp%20Image%202026-04-15%20at%208.17.37%20PM.jpeg",
  instagram: "https://www.instagram.com/klinarakids?igsh=MXFsZjRqYzI1cmxjaA==",
};

export const programs = [
  {
    id: 0,
    title: "Little Nest (Childcare)",
    description:
      "A safe and nurturing space where children receive attentive care, structured playtime, and emotional support in a comfortable environment.",
    features: [
      "Safe Environment",
      "Attentive Care",
      "Structured Playtime",
      "Emotional Support",
    ],
    duration: "9:00 AM - 5:00 PM",
  },
  {
    id: 1,
    title: "Tiny Sprouts (Playgroup | 2-3 years)",
    description:
      "A playful introduction to structured learning where children explore social interaction, sensory play, music, and creative activities.",
    features: [
      "Sensory Exploration",
      "Language Development",
      "Social Interaction",
      "Motor Skill Development",
    ],
    duration: "9:00 AM - 12:00 PM",
  },
  {
    id: 2,
    title: "Growing Buds (Nursery | 3-4 years)",
    description:
      "A stage where curiosity grows as children begin exploring early literacy, numeracy, and creative expression through engaging activities.",
    features: [
      "Early Language & Communication",
      "Basic Numbers & Shapes",
      "Creative Arts & Storytelling",
      "Social & Emotional Development",
    ],
    duration: "8:30 AM - 12:30 PM",
  },
  {
    id: 3,
    title: "Blooming Flowers (Junior KG | 4-5 years)",
    description:
      "Children strengthen their foundational learning through structured activities that develop early reading, writing, and logical thinking skills.",
    features: [
      "Early Reading & Phonics",
      "Writing Readiness",
      "Number Concepts",
      "Problem-Solving Skills",
    ],
    duration: "8:30 AM - 2:00 PM",
  },
  {
    id: 4,
    title: "Bright Blossoms (Senior KG | 5-7 years)",
    description:
      "The final stage of preschool where children build strong academic foundations and develop confidence before transitioning to primary school.",
    features: [
      "Reading & Comprehension",
      "Writing & Sentence Formation",
      "Mathematical Thinking",
      "Creative Expression & Confidence Building",
    ],
    duration: "8:30 AM - 2:00 PM",
  },
];

export const faculty = [
  {
    id: 1,
    name: "Mrs. Priya Sharma",
    role: "Principal & Lead Educator",
    qualification: "M.Ed in Early Childhood Education",
    experience: "15 years",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400",
  },
  {
    id: 2,
    name: "Ms. Anjali Reddy",
    role: "Senior Teacher - Nursery",
    qualification: "B.Ed, Montessori Certified",
    experience: "10 years",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400",
  },
  {
    id: 3,
    name: "Mrs. Meera Patel",
    role: "Lead Teacher - LKG/UKG",
    qualification: "M.A. in Child Psychology",
    experience: "12 years",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=400",
  },
  {
    id: 4,
    name: "Ms. Kavita Nair",
    role: "Music & Movement Specialist",
    qualification: "B.A. in Music Education",
    experience: "8 years",
    image: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400",
  },
];

export const testimonials = [
  {
    id: 1,
    parent: "Rajesh & Suma Kumar",
    child: "Aarav (UKG)",
    text: "Klinara Kids has been a blessing for our son. The teachers are caring, and the Asian curriculum approach has helped him connect with his roots while learning.",
    rating: 5,
  },
  {
    id: 2,
    parent: "Venkat Rao",
    child: "Diya (LKG)",
    text: "The quality of education and individual attention each child receives is remarkable. Diya loves going to school every day!",
    rating: 5,
  },
  {
    id: 3,
    parent: "Deepa Mehta",
    child: "Arjun (Nursery)",
    text: "We're impressed with the holistic development approach. Arjun has grown so much in confidence and social skills.",
    rating: 5,
  },
  {
    id: 4,
    parent: "Sridhar & Lakshmi",
    child: "Ananya (UKG)",
    text: "Excellent infrastructure and dedicated teachers. The values-based education is exactly what we were looking for.",
    rating: 5,
  },
];

export const events = [
  {
    id: 1,
    title: "Grand Opening Ceremony",
    date: "January 15, 2026",
    description:
      "Join us for the grand inauguration of Klinara Kids with cultural performances and open house.",
    image: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=600",
    status: "upcoming",
  },
  {
    id: 2,
    title: "Cultural Day Celebration",
    date: "February 20, 2026",
    description:
      "Students showcase traditional dances, songs, and cultural activities from various Asian traditions.",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600",
    status: "upcoming",
  },
  {
    id: 3,
    title: "Parent Orientation Workshop",
    date: "January 25, 2026",
    description:
      "Interactive session for parents to understand our curriculum and teaching methodology.",
    image: "https://images.unsplash.com/photo-1540479859555-17af45c78602?w=600",
    status: "upcoming",
  },
];

export const gallery = [
  "https://images.unsplash.com/photo-1759678444821-565ff103465c?w=600",
  "https://images.unsplash.com/photo-1554721299-e0b8aa7666ce?w=600",
  "https://images.unsplash.com/photo-1761208663763-c4d30657c910?w=600",
  "https://images.unsplash.com/photo-1574130303188-31a915382726?w=600",
  "https://images.unsplash.com/photo-1668620589356-56ba14193005?w=600",
  "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600",
  "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=600",
  "https://images.unsplash.com/photo-1540479859555-17af45c78602?w=600",
];

export const features = [
  {
    id: 1,
    title: "Smart Learning with Elthea AI",
    description:
      "US-based AI platform that discovers your child's hidden strengths through playful behavior assessment games",
    icon: "Laptop",
  },
  {
    id: 2,
    title: "Activity-Based Learning",
    description:
      "Children learn best through experience. Our classrooms focus on hands-on activities that encourage curiosity and discovery",
    icon: "BookOpen",
  },
  {
    id: 3,
    title: "Strong Value Foundation",
    description:
      "We nurture essential life skills such as respect, discipline, kindness, and responsibility",
    icon: "Heart",
  },
  {
    id: 4,
    title: "Focus on Life Skills",
    description:
      "Children develop independence through daily habits, social interaction, and real-world experiences",
    icon: "Users2",
  },
  {
    id: 5,
    title: "Safe & Nurturing Environment",
    description:
      "A caring environment where every child feels valued, confident, and encouraged to grow",
    icon: "Shield",
  },
  {
    id: 6,
    title: "Experienced Faculty",
    description:
      "Highly qualified and caring teachers dedicated to nurturing each child's unique potential",
    icon: "Users",
  },
];

export const virtualTourSpots = [
  {
    id: 1,
    title: "Reception & Waiting Area",
    description: "Welcoming space with comfortable seating for parents",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600",
  },
  {
    id: 2,
    title: "Classrooms",
    description:
      "Bright, spacious classrooms with age-appropriate learning materials",
    image: "https://images.unsplash.com/photo-1574130303188-31a915382726?w=600",
  },
  {
    id: 3,
    title: "Activity Room",
    description: "Dedicated space for music, dance, and creative activities",
    image: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=600",
  },
  {
    id: 4,
    title: "Outdoor Play Area",
    description: "Safe and fun play equipment for physical development",
    image: "https://images.unsplash.com/photo-1587825140632-6fb7ad9dfafc?w=600",
  },
];

export const admissionSteps = [
  {
    step: 1,
    title: "Inquiry",
    description: "Fill out the inquiry form or contact us directly",
  },
  {
    step: 2,
    title: "School Visit",
    description: "Schedule a tour to see our facilities and meet our team",
  },
  {
    step: 3,
    title: "Registration",
    description: "Complete the registration form with required documents",
  },
  {
    step: 4,
    title: "Interaction",
    description: "Parent-teacher interaction to understand child's needs",
  },
  {
    step: 5,
    title: "Confirmation",
    description: "Pay admission fee and receive confirmation",
  },
];
